import { VStack, type ResponsiveValue } from '@chakra-ui/react';
import { type FC, type RefObject } from 'react';

import { FanPresentationRow } from '$/components/core/Collection/MaterialPresentation/FanPresentationRow';
import { ListPresentationItem } from '$/components/core/Collection/MaterialPresentation/ListPresentationItem';
import {
  type Material,
  type MaterialType,
} from '$/services/usecases/materials/mapper/materials';
import { repeat } from '$/utils/arrayUtils';

interface Props {
  observer: RefObject<HTMLDivElement | null>;
  setActiveMaterial: (material: Material) => void;
  materials: Material[];
  type: MaterialType;
  isLoading: boolean;
  disableHovering?: boolean;
  itemHeight?: ResponsiveValue<string>;
  rowGap?: ResponsiveValue<string>;
  borderRadius?: string;
  activeMaterialId?: string;
  hideFavoriteButton?: boolean;
}

export const FanPresentation: FC<Props> = ({
  observer,
  setActiveMaterial,
  materials,
  type,
  isLoading,
  disableHovering,
  itemHeight,
  rowGap = '3',
  borderRadius,
  activeMaterialId,
  hideFavoriteButton = false,
}) => {
  const fanPages = materials.reduce<Record<number, Material[]>>((acc, curr) => {
    const page = curr.page;
    if (!page || page === 0) return acc;
    acc[page] = [...(acc[page] || []), curr];
    return acc;
  }, {});

  const sortedKeys = Object.keys(fanPages).sort(
    (a, b) => Number(a) - Number(b),
  );

  return (
    <VStack gap={rowGap} overflow='auto'>
      {sortedKeys.map((page, i) => (
        <FanPresentationRow
          key={page}
          fanPage={fanPages[Number(page)]}
          showObserver={i === sortedKeys.length - 5}
          observer={observer}
          setActiveMaterial={setActiveMaterial}
          disableHovering={disableHovering}
          height={itemHeight}
          borderRadius={borderRadius}
          activeMaterialId={activeMaterialId}
          hideFavoriteButton={hideFavoriteButton}
        />
      ))}

      {isLoading &&
        repeat(20).map((i) => (
          <ListPresentationItem
            materialType={type}
            key={i}
            hideFavoriteButton={hideFavoriteButton}
          />
        ))}
    </VStack>
  );
};
